module.exports = __webpack_public_path__ + "images/3acf06f1562a89b1b988fcb3b44801a5.svg";